import { useEffect } from "react";
import AfeDetail from "./AfeDetail";
import { CONSTANTS } from "client/utils/constants";
import { AfeTypeFields } from "client/utils/AssetUtil";

const AfeDetailContainer = (props: any) => {
    const { 
        item,
        assetOrderHeaderDetail 
    } = props;

    return (
        <AfeDetail
            item={item}
            fields={AfeTypeFields[assetOrderHeaderDetail?.afeType]}
            assetOrderHeaderDetail={assetOrderHeaderDetail}
        />
    )
}

export default AfeDetailContainer;